'use client';

import React from 'react';
import { installationCheckStepsConfig } from './installation-check-steps-config';
import InstallationCheckSurvey from './installation-check-survey';

export default function InstallationCheck({ isUS = false }: { isUS: boolean }) {
  return (
    <InstallationCheckSurvey stepConfigurations={installationCheckStepsConfig} isUS={isUS} />
  );
}
